import PropTypes from 'prop-types';
import React from 'react';
import { routeMap } from 'router/routes';
import moment from 'utils/moment';
import LinkWrapper from 'containers/LinkWrapperContainer';
import config from 'config';

export function MobilizationReportLink(props) {
  const { position, contactInfo } = props;
  if (
    (contactInfo && contactInfo?.gender === '2') ||
    moment().diff(contactInfo?.dateOfBirth, 'year') < 18 ||
    config.isInspectorArm
  ) {
    return null;
  }

  return (
    <LinkWrapper
      href={routeMap.mobilizationReport}
      className={`link white text-decoration-none ${position === 'top' ? 'mb-3' : 'mt-3'}`}
    >
      Сообщить о факте мобилизации{position === 'top' && ' ›'}
    </LinkWrapper>
  );
}

MobilizationReportLink.propTypes = {
  position: PropTypes.oneOf(['top', 'bottom']),
  contactInfo: PropTypes.object,
};
